import { render } from "./InquiryManageListPage.vue?vue&type=template&id=2a14fe8f&lang=true"
import script from "./InquiryManageListPage.vue?vue&type=script&lang=js"
export * from "./InquiryManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__